import { getRequestHeaders, handleRes } from "utils";
import { Permission } from "types";

export const getTenantPermissions = (id: number): Promise<Permission[]> => {
  return fetch(`${window.USER_BASE_URL}/tenant/${id}/permissions`, {
    method: "GET",
    ...getRequestHeaders(),
  })
    .then((res) => handleRes<Permission[]>(res, 200))
    .catch((e) => {
      throw e;
    });
};

export const updatePermission = async (
  body: Array<Permission>,
  tenantID: number,
): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/tenant/${tenantID}/permissions`, {
    method: "PUT",
    ...getRequestHeaders(),
    body: JSON.stringify(body),
  });
};
